import { useState, useEffect } from "react";
import { sql } from "../componentes/api.js";
import { Chip, Stack } from "@mui/material";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VerAnexosDoc from "./VerAdjuntos.jsx";

const Anexos = (props) => {
  const [anexos, setAnexos] = useState([]);
  const [verAnexos, setVerAnexos] = useState(false);
  const [archivoAnexo, setArchivoAnexo] = useState("");
  const [tipoArchivo, setTipoArchivo] = useState("");

  useEffect(() => {
    const consultar = async () => {
      if (!props.Actividad !== undefined && props.Actividad !== null) {
        const reg = await sql("getAnexosActividad", "POST", {
          Proyecto: props.Proyecto,
          Actividad: props.Actividad,
        });

        if (reg.toString().length > 0) setAnexos(reg);
        else setAnexos([]);
      }
    };

    consultar();
  }, [props.Proyecto, props.Actividad]);

  const getIconoTipoArchivo = (tipo) => {
    if (tipo === 1) {
      return <SmartDisplayIcon />;
    } else if (tipo === 2) {
      return <CameraAltIcon />;
    } else if (tipo === 3) {
      return <FilePresentIcon />;
    } else if (tipo === 4) {
      return <VolumeUpIcon />;
    }
  };

  const organizarAnexo = (event, archivo, tipo) => {
    event.preventDefault();
    setVerAnexos(true);
    setArchivoAnexo(archivo);
    setTipoArchivo(tipo);
  };

  return (
    <div className="container">
      <div className="row">
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          sx={{ flexWrap: "wrap" }}
        >
          {anexos.map((reg, i) => {
            return (
              <Chip
                key={i}
                icon={getIconoTipoArchivo(reg.TipoArchivo)}
                label={reg.Ruta}
                color="secondary"
                onClick={(event) =>
                  organizarAnexo(event, reg.Ruta, reg.TipoArchivo)
                }
              />
            );
          })}
        </Stack>
      </div>

      {verAnexos === true && (
        <VerAnexosDoc
          setVerAnexos={setVerAnexos}
          ruta={"proyectos/actividades/"}
          archivo={archivoAnexo}
          tipoAnexo={tipoArchivo}
        />
      )}
    </div>
  );
};

export default Anexos;
